import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegrationOtp from "../Common/Axios/axiosIntegrationOtp";
export const pointReversalPostApi = async (payload) => {
  const { data = {} } = await axiosIntegrationOtp.post(API.sendOtp, payload);
  return data;
};
